// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rayquaza_mega: PokeData = {
  "id": 10079,
  "name": "rayquaza-mega",
  "height": 108,
  "weight": 3920,
  "base_experience": 351,
  "types": [
    PokeType.DRAGON,
    PokeType.FLYING
  ],
  "api_moves": [
    "fly",
    "hyper-beam",
    "rest",
    "scary-face",
    "outrage",
    "twister",
    "crunch",
    "extreme-speed",
    "ancient-power",
    "hyper-voice",
    "dragon-dance",
    "air-slash",
    "dragon-pulse"
  ],
  "moves": [
    "scary-face",
    "outrage",
    "crunch",
    "ancient-power",
    "hyper-voice",
    "dragon-dance",
    "air-slash",
    "dragon-pulse",
    "roost",
    "tailwind",
    "great-roar",
    "peck",
    "acrobatics"
  ],
  "evolution_chain": {
    "id": 200,
    "item": null,
    "species": [
      {
        "name": "rayquaza",
        "order": 414,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 103,
    "speed": 116,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
